<template>
  <div class="flex h-full">
    <section class="illustration_section hidden sm:flex items-center h-full image_bg w-1/3 relative bg-theme-primary">
      <div class="p-10 flex flex-col w-full">
        <div class="mb-10 self-center">
          <img alt="logo" src="../../assets/images/white_black_logo.svg" style="width:180px">
        </div>
        <div class="w-full flex justify-center">
          <p class="">
            Quality, Quick
          </p>
        </div>
      </div>
    </section>
    <section class=" w-full sm:w-2/3 p-3 sm:p-5 signup_section flex flex-col">
      <div class="flex sm:hidden pt-5 justify-center">
        <img alt="logo" src="../../assets/images/logo_yellow.svg" style="width:100px">

      </div>
      <div class="text-right order-4 sm:order-1 pt-5 sm:pt-0 flex justify-center sm:justify-end ">
        <p class="text-sm font-medium ">Not a Member? <span class="text-theme-primary cursor-pointer"
                                                            @click="$router.push('/sign-up')">Sign up now</span></p>
      </div>
      <div class="mt-5 sm:mt-24 order-2">
        <div class="text-center">
          <p class="font-bold text-2xl sm:text-3xl">Vendor Sign In</p>
        </div>
      </div>
      <div class="mt-5 sm:mt-10 order-3">
        <form class="px-2 sm:px-10 md:px-32 sm:pt-6  sm:pb-8 sm:mb-4" @submit.prevent="login">
          <div class="mb-6">
            <label class="block text-gray-700 text-left sm:text-xl font-semibold mb-1" for="email">
              Email
            </label>
            <input
              id="email"
              v-model="user_details.email"
              class="appearance-none border-none rounded-lg w-full py-4 px-4 leading-tight focus:outline-none focus:shadow-outline"
              placeholder="" type="text">
          </div>
          <div class=" mb-6 sm:mb-8">
            <label class="block text-gray-700 text-left sm:text-xl font-semibold mb-1" for="password">
              Password
            </label>
            <!--            <input-->
            <!--              id="password"-->
            <!--              class="shadow appearance-none border border-red-500 rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline"-->
            <!--              placeholder="******************" ">-->
            <input
              id="password"
              v-model="user_details.password"
              class="appearance-none border-none rounded-lg w-full py-4 px-4 leading-tight focus:outline-none focus:shadow-outline"
              placeholder="" type="password">
            <!--            <p class="text-red-500 text-xs italic">Please choose a password.</p>-->
          </div>
          <div class="flex items-center justify-between">
            <button
              class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-12 sm:px-16 md:px-32 rounded focus:outline-none focus:shadow-outline"
              type="submit">
              Sign In
            </button>
            <a class="inline-block align-baseline font-bold text-sm text-black hover:text-gray-800" href="#">
              Forgot Password?
            </a>
          </div>
        </form>
      </div>
    </section>
  </div>
</template>

<script>
// import credentials from '@/firebase/credentails'
import firebase from 'firebase'
// import Illustration from '@/components/auth/Illustration'
// import 'firebase/auth'
export default {
  components: {
    // Illustration
  },
  name: 'Login',
  data: () => ({
    user_details: {
      email: '',
      password: ''
    }
  }),
  methods: {
    // login () {
    //   this.axios.get(`https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=${credentials.config.apiKey}`).then((response) => {
    //     console.log(response.data)
    //   })
    // },
    login () {
      firebase.auth().signInWithEmailAndPassword(this.user_details.email, this.user_details.password)
        .then((res) => {
          console.log(res.user.uid)
          const path = `/vendors/${res.user.uid}`
          const user = firebase.database().ref(path).once('value')
          console.log(user)
          this.$router.push('/')
        })
        .catch(
          () => {
            // alert(err.code)
          }
        )
    }
  },
  created () {
    // instance.login()
  }
}
</script>

<style scoped>
input {
  background-color: #F6F6F6;
}

button {
  @apply text-white shadow-lg rounded-lg;
  background: linear-gradient(75deg, #F4BE19 0%, #f4cf6d 100%);
}

button:hover {
  @apply text-white shadow-lg rounded-lg;
  background: linear-gradient(90deg, #f4cf6d 0%, #F4BE19 100%);
}
</style>
